import React, { useState, useEffect } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import { useWeb3 } from "../../context/Web3Context";
import { useContract } from "../../hooks/useContract";
import "./BottomTabBar.css";

const BASE_TABS = [
  { path: "/home", label: "Home", icon: "\u2302" },
  { path: "/star", label: "Star", icon: "\u2605" },
  { path: "/global", label: "Global", icon: "\u25C6" },
  { path: "/reports", label: "Reports", icon: "\u2630" },
];

const ADMIN_TAB = { path: "/admin", label: "Admin", icon: "\u2699" };

export default function BottomTabBar() {
  const { account } = useWeb3();
  const contracts = useContract();
  const location = useLocation();
  const navigate = useNavigate();
  const [isAdmin, setIsAdmin] = useState(false);

  useEffect(() => {
    if (account && contracts) checkAdmin();
    else setIsAdmin(false);
    // eslint-disable-next-line
  }, [account, contracts]);

  async function checkAdmin() {
    try {
      const [owner, admin] = await Promise.all([
        contracts.data.owner(),
        contracts.data.admin(),
      ]);
      const lower = account.toLowerCase();
      setIsAdmin(lower === owner.toLowerCase() || lower === admin.toLowerCase());
    } catch {
      setIsAdmin(false);
    }
  }

  if (!account) return null;

  const tabs = isAdmin ? [...BASE_TABS, ADMIN_TAB] : BASE_TABS;

  return (
    <nav className="bottom-tab-bar">
      {tabs.map((tab) => {
        const active = location.pathname.startsWith(tab.path);
        return (
          <button
            key={tab.path}
            className={`btab ${active ? "btab-active" : ""}`}
            onClick={() => navigate(tab.path)}
          >
            <span className="btab-icon">{tab.icon}</span>
            <span className="btab-label">{tab.label}</span>
            {active && <span className="btab-indicator" />}
          </button>
        );
      })}
    </nav>
  );
}
